import React, {FC, useState} from 'react';
import messages from '../messages';
import orderColumns from './columns';
import CollapseTable from 'components/collapse-table/collapse-table';
import {useTranslation} from 'react-i18next';
import {Button} from 'reactstrap';
import {ObjectId} from 'types/object-id';

interface Props {
  id?: ObjectId;
}

const OrderTable: FC<Props> = props => {
  const {t} = useTranslation();
  const {id} = props;
  const [isOpen, setIsOpen] = useState(false);
  const filterDAte = [
    new Date('2015/01/01').toISOString(),
    new Date().toISOString(),
  ].join(',');

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Button color="light" onClick={toggle} className="mb-3 w-100">
        {t(...messages.order())}
      </Button>
      <CollapseTable
        isOpen={isOpen}
        columns={orderColumns}
        url={`orders?type=CLIENT&filter[variant_id]=${id}&limit=10&filter[order_date]=${filterDAte}&for_stats=true`}
        name="directory-client-orders"
      />
    </div>
  );
};

export default OrderTable;
